import { render, staticRenderFns } from "./TaskDetailItem.vue?vue&type=template&id=4529543c&scoped=true&"
import script from "./TaskDetailItem.vue?vue&type=script&lang=js&"
export * from "./TaskDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailItem.vue?vue&type=style&index=0&id=4529543c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529543c",
  null
  
)

export default component.exports